import React from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { setSelectedTheme } from "../redux/themeSice";

export const ThemeChanger = () => {
    const theme= [{key: "theme1", value: "Theme 1"},{key: "theme2", value: "Theme 2"},{key: "theme3", value: "Theme 3"}]
    const dispatch = useAppDispatch();
    const selectedTheme = useAppSelector(state => state.theme.selectedTheme);


  return (
    <select id="themeChanger" className="bg-blue-500 text-white px-4 py-2 rounded w-1/6" 
    value={selectedTheme} onChange={(e) => dispatch(setSelectedTheme({selectedTheme: e.target.value}))}>
            {theme.map((opt) => (
                <option value={opt.key}>{opt.value}</option>
            ))}
    </select>
  );
};